export enum SANSHO_LEVEL {
  DTC_03_01 = '0',
  DTC_01_01 = '2',
  DTC_01_02 = '2',
  DTC_02_02 = '2',
  CM_02_02 = '1',
}
export enum REGISTERED_TYPE {
  DTC_01_01 = 0,
  DTC_01_02 = 1,
  DTC_02_02 = 2,

  CM_02_02 = 2,
  DTC_03_01 = 2,
}

export enum RKY_CREATION_FLG {
  NotCreated = 0, // 未作成：現場へ入場のみ
  InProgress = 1, // 作成中：RKY or 玉掛け or 足場
  Completed = 2, // 作成完了：RKY & 玉掛け & 足場
  Submitted = 3, // 監督へ提出済
}

export enum APPROVAL_FLG {
  NotApprovaled = 0, //未承認
  KantokuApprovaled = 1, //監督承認済
  KanrishaApprovaled = 2, //管理者承認済
  Returned = 3, //差戻
}

export enum RETRUNER_ROLE {
  None = 0, //unknown
  Director = 1, //監督
  Manager = 2, //管理者
}
